import React, { useState } from "react";
import { SheetCard } from "./gallery/SheetCard";
import { Gallery, Card } from "@patternfly/react-core";
import { NoResults } from "shared/utils/NoResults";

export const SheetsGallery = ({
  props,
  context,
  Icons,
  sheets,
  setSheets,
  groupFilter
}) => {
  const [selectedSheetId, setSelectedSheetId] = useState(null);

  return (
    <>
      {(sheets || []).length === 0 ? (
        <NoResults
          title="Nie znaleziono wyników"
          message="Żaden arkusz nie spełnia kryteriów wyszukiwania lub filtrów."
        />
      ) : (
        <Gallery hasGutter minWidths={{ default: "260px" }}>
          {(sheets || []).map((row) => {
            const isSelected = selectedSheetId === row.id;

            return (
              <Card
                key={row.id}
                onClick={() => setSelectedSheetId(row.id)}
                style={{
                  borderRadius: "14px",

                  border: isSelected
                    ? "1px solid var(--pf-t--global--border--color--brand--default)"
                    : "1px solid var(--pf-t--global--border--color--default)",

                  backgroundColor: isSelected
                    ? "var(--pf-t--global--background--color--action--plain--clicked)"
                    : "var(--pf-t--global--background--color--primary--default)",

                  boxShadow: isSelected
                    ? "var(--pf-t--global--box-shadow--sm)"
                    : "none",

                  transition:
                    "background-color 0.2s, border-color 0.2s, box-shadow 0.2s",

                  overflow: "visible",
                }}
              >
                <SheetCard
                  context={context}
                  props={props}
                  row={row}
                  Icons={Icons}
                  groupFilter={groupFilter}
                  setSheets={setSheets}
                  isSelected={isSelected}
                />
              </Card>
            );
          })}
        </Gallery>
      )}
    </>
  );
};